import { useState } from "react";
import { faqs } from "@/mocks/archiveData";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <p className="text-sm font-medium tracking-wide text-accent-700">FAQ · 常见问题</p>
          <h2 className="mt-3 text-2xl text-foreground-950 md:text-4xl">关于历史快照，你想知道的都在这里</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-700 md:text-base">
            针对快照如何保存、旧版如何找回、对比怎么用等高频问题，我们整理了以下说明。仍有疑问可通过页面底部联系方式咨询。
          </p>
          <a
            href="#contact"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            还有问题？联系我们
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100/60">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={i} className={i === 0 ? "rounded-t-2xl" : ""}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-semibold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      Q
                    </span>
                    <span className="text-sm font-medium leading-6 text-foreground-950 md:text-base">{f.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[3.5rem] pr-6 text-sm leading-6 text-foreground-700 md:px-6 md:pl-[4.2rem]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}